/**
 * @generated SignedSource<<857a29df7c9f953c6ade802bcb41fb0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TaskOriginalBulkUpdateInput = {
  originalTaskSequence: number;
  tasks: ReadonlyArray<string>;
};
export type TaskOriginalBulkUpdateDialog_taskOriginalBulkUpdateMutation$variables = {
  input: TaskOriginalBulkUpdateInput;
};
export type TaskOriginalBulkUpdateDialog_taskOriginalBulkUpdateMutation$data = {
  readonly taskOriginalBulkUpdate: ReadonlyArray<{
    readonly id: string;
    readonly sequence: number;
  }>;
};
export type TaskOriginalBulkUpdateDialog_taskOriginalBulkUpdateMutation = {
  response: TaskOriginalBulkUpdateDialog_taskOriginalBulkUpdateMutation$data;
  variables: TaskOriginalBulkUpdateDialog_taskOriginalBulkUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Task",
    "kind": "LinkedField",
    "name": "taskOriginalBulkUpdate",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sequence",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskOriginalBulkUpdateDialog_taskOriginalBulkUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TaskOriginalBulkUpdateDialog_taskOriginalBulkUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7b87db45584662f314518b9a668e112a",
    "id": null,
    "metadata": {},
    "name": "TaskOriginalBulkUpdateDialog_taskOriginalBulkUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation TaskOriginalBulkUpdateDialog_taskOriginalBulkUpdateMutation(\n  $input: TaskOriginalBulkUpdateInput!\n) {\n  taskOriginalBulkUpdate(input: $input) {\n    id\n    sequence\n  }\n}\n"
  }
};
})();

(node as any).hash = "69ccca71b2b293f6be9851cc2e6fb2e4";

export default node;
